module.exports = "/static/assets/99041652f36815b1702b8bc7f019f625.gif";